import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { HistoryDetailsPaymentServiceProps } from "./types";
import { messages } from "./messages";
import { useFormatter } from "hooks/utils/useFormatter";
import dayjs from "dayjs";

export const HistoryDetailsPaymentService: React.FC<
  HistoryDetailsPaymentServiceProps
> = ({ data: payment }) => {
  const { formatMessage } = useIntl();
  const { formatValue } = useFormatter();

  const getStatus = (state?: string) => {
    let stClass = "text-[--color-warning]";
    let st = formatMessage(messages.statusInProgress);

    switch (state) {
      case "succeed":
        stClass = "text-[--color-success]";
        st = formatMessage(messages.approved);
        break;
      case "failed":
        stClass = "text-[--color-error]";
        st = formatMessage(messages.rejected);
        break;
    }
    return <span className={stClass}>{st}</span>;
  };
  return (
    <div className="flex flex-col gap-y-6">
      <DetailsField
        label={formatMessage(messages.youPay)}
        value={payment.extra_data.merchant_name ?? ""}
      />
      <DetailsField
        label={formatMessage(messages.alias)}
        value={payment.extra_data.friendly_name ?? ""}
      />
      <DetailsField
        label={formatMessage(messages.adjustmentAmount)}
        value={`${formatValue(payment.amount || "", payment.precision)} ${
          payment.currency_id ? payment.currency_id.toUpperCase() : "ARS"
        }`}
      />
      <DetailsField
        label={formatMessage(messages.currencyUsed)}
        value={
          payment.extra_data.out_currency_ticker_id
            ? payment.extra_data.out_currency_ticker_id.toUpperCase()
            : "-"
        }
      />
      <DetailsField
        label={formatMessage(messages.dueDate)}
        value={
          payment.extra_data.due_date
            ? dayjs(payment.extra_data.due_date).format("DD.MM.YYYY")
            : formatMessage(messages.noDate)
        }
      />
      <DetailsField
        label={formatMessage(messages.status)}
        value={getStatus(payment.extra_data.state)}
      />
      <DetailsField
        label={formatMessage(messages.transactionNumber)}
        value={payment.extra_data?.transaction_number ?? ""}
      />
      <DetailsField
        label={formatMessage(messages.controlNumber)}
        value={payment.extra_data?.control_number ?? ""}
      />
    </div>
  );
};
